<div class="st-drawer-wrapper">
  <!-- Dummy element for autofocus -->
  <a href=""></a>
  <!--  Header  -->
  <div class="st-drawer-header show-border unchange-direction">
    <div class="flex-center gap-075 header-data">
      @if (isMobile$ | async) {
<app-st-icon
        class="text-header-16" style="cursor: pointer; width: 27px" (click)="close()" name="close"></app-st-icon>
      }
      <app-st-icon [avatar]="true" [name]="'description'"></app-st-icon>
      <div class="text-label-14 doc-info">
      <div class="flex-center" style="justify-content: start">
        <strong class="text-dark">{{nzData.document.type}}</strong>  <span style="margin: 0 6px">·</span>  <label class="text-nowrap" style="display: block; max-width: 200px;">{{nzData.document.name}}</label>
      </div>
    </div>
    </div>

    <div class="flex-center gap-200">
      @if (nzData.showOptions && (!!authService.loggedUser$.value?.uploadDocumentsUnlimited || !!authService.loggedUser$.value?.uploadDocumentsLimited)) {
        <button
                nz-button nzType="text" nzShape="circle" nzSize="default" nz-dropdown
                [nzDropdownMenu]="actionMenu" nzTrigger="click">
          <app-st-icon name="more_vert" [bold]="true"></app-st-icon>
        </button>
      }

      <nz-dropdown-menu #actionMenu="nzDropdownMenu">
        <ul nz-menu>
          <li nz-menu-item (click)="openDocModal('delete')">
            <button class="flex-center gap-100"
                    nz-button nzType="text" nzShape="circle" nzSize="default">
              <app-st-icon name="delete" [bold]="true"></app-st-icon>
              <span class="text-label-14 text-dark">Eliminar</span>
            </button>
          </li>
        </ul>
      </nz-dropdown-menu>

<!--      <button class="flex-center gap-075" [nzShape]="(isMobile$ | async) ? 'circle' : 'round'"-->
<!--              (click)="downloadDocument()"-->
<!--              nzSize="default" nz-button [nzType]="(isMobile$ | async) ? 'text' : 'default'">-->
<!--        <app-st-icon [class.prefix]="!(isMobile$ | async)" class="text-btn-16" [bold]="true" name="download"></app-st-icon>-->
<!--        <span *ngIf="!(isMobile$ | async)" class="text-btn-14">Descargar</span>-->
<!--      </button>-->

      <app-st-icon [style.visibility]="(isMobile$ | async) ? 'hidden' : 'visible'"
                   class="text-header-16" style="cursor: pointer; width: 27px" (click)="close()" name="close"></app-st-icon>
    </div>
  </div>

  <!--  Content  -->
  <div class="flex st-drawer-content">
    <!-- Panel izquierdo -->
    <div class="left-panel flex flex-column" [ngClass]="(isMobile$ | async) ? 'gap-100' : 'gap-400'">
      <div class="flex flex-column" [ngClass]="(isMobile$ | async) ? 'gap-100' : 'gap-400'">
        <app-list-key-value
          [data]="setKeyValueData(1)"
          [pairMaxWidth]="{value: 570, unit: 'px'}"
          [keysWidth]="{value: 120, unit: 'px'}"
          [innerRowGap]="{value: 6, unit: 'px'}"
          [innerColumnGap]="{value: 16, unit: 'px'}"
          [valuesMaxWidth]="{value: 90, unit: '%'}"
        ></app-list-key-value>

        <nz-divider style="margin: 0" nzType="horizontal"></nz-divider>

        <span class="text-header-18">Validación</span>

        @if (this.nzData.document.validationStatus | docState; as stateData) {
          <div style="margin-left: 0" class="status-dot-wrapper">
            <div class="status-dot" [ngClass]="stateData.class ? stateData.class : ''" ></div>
            <label>{{stateData.name}}</label>
          </div>
        }

        <app-list-key-value class="flex-grow-1"
          [data]="setKeyValueData(2)"
          [keysWidth]="{value: 120, unit: 'px'}"
          [innerColumnGap]="{value: 16, unit: 'px'}"
          [innerRowGap]="{value: (isMobile$ | async) ? 8 : 32, unit: 'px'}"
        ></app-list-key-value>

        @if (!!authService.loggedUser$.value?.validateDocuments) {
          <div class="flex-center-between btn-container gap-200">
            @if (nzData.document.validationStatus !== 'NonValidated') {
              <button (click)="openDocModal('reject')" nzShape="round" nzSize="default" nz-button nzType="default">
                <app-st-icon class="prefix" [bold]="true" name="close"></app-st-icon>
                <span class="text-btn-14">Rechazar</span>
              </button>
            }

            @if (nzData.document.validationStatus === 'ValidationPending') {
              <button (click)="openDocModal('validate')" nzShape="round"
                      nzSize="default" nz-button nzType="primary">
                <app-st-icon class="prefix" [bold]="true" name="check_circle"></app-st-icon>
                <span>Validar</span>
              </button>
            }

            @if (nzData.document.validationStatus !== 'ValidationPending') {
              <button (click)="openDocModal('return')" nzShape="round" nzSize="default" nz-button nzType="primary">
                <span>Volver a pendiente</span>
              </button>
            }

  <!--          <button (click)="openDocModal('correct')" *ngIf="nzData.document.validationStatus === 'NonValidated'" class="full"-->
  <!--                  nzShape="round" nzSize="default" nz-button nzType="primary">-->
  <!--            <app-st-icon class="prefix" [bold]="true" name="upload"></app-st-icon>-->
  <!--            <span>Corregir</span>-->
  <!--          </button>-->
          </div>
        }
      </div>

      @if (!(isMobile$ | async) && this.nzData.document.chat) {
        <app-chat [chatName]="nzData.document.name"
                  [chat]="this.nzData.document.chat"
        ></app-chat>
      }
    </div>

    <!-- Panel derecho -->
<!--    <ngx-extended-pdf-viewer-->
<!--      [height]="(isMobile$ | async) ? '100%' : undefined"-->
<!--      [zoom]="(isMobile$ | async) ? 45 : undefined"-->
<!--      [src]="pdfSrc"-->
<!--      [showToolbar]="false">-->
<!--    </ngx-extended-pdf-viewer>-->
  </div>

</div>

@if ((isMobile$ | async) && this.nzData.document.chat) {
<app-chat [chatName]="nzData.document.name"
  [chat]="this.nzData.document.chat"
></app-chat>
}
